import React from 'react';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Components
import LocationSearchForm from '../LocationSearchForm';
import HomebannerSlider from '../../homeSliderBanner/HomeBannerSlider';

import s from '../SliderAnimation/SliderAnimation.css';

const Layout1 = ({ homeBannerImages, title, content }) => {

  return (
    <div>
      <div className={cx('homeBannerSliderContainer')}>
        <div>
          <div>
            <HomebannerSlider homeBannerImages={homeBannerImages} />
          </div>
          <div className={cx(s.container, s.ContainerTab, s.layoutOneFormContainer)}>
            <div>
              <h1 className={cx(s.noMargin, s.bannerCaptionText, s.bannerCaptionText)}>
                <span className={s.bannerCaptionHighlight}>{title}</span> {content}
              </h1>
              <div className={s.searchbox}>
                <LocationSearchForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withStyles(s))(Layout1);